import type {Moment} from 'moment-timezone'

import {
  HistoryMaterialStorage,
  HistoryStorageWithMaterial,
  MaterialStorage,
  MaterialStoragesHistory,
  StorageWithMaterial
} from '../types'

import {getRelevantHistoryEntry} from './history'

export const isStorageWithMaterialGuard = (
  storage: MaterialStorage
): storage is StorageWithMaterial => storage.materialId !== null

export const isHistoryStorageWithMaterialGuard = (
  storage: HistoryMaterialStorage
): storage is HistoryStorageWithMaterial => storage.materialId !== null

export const getStoragesFromHistory = (history: MaterialStoragesHistory, date: Moment) =>
  Object.values(history)
    .map((storageHistory) => getRelevantHistoryEntry(storageHistory, date))
    .filter((entry): entry is HistoryMaterialStorage => Boolean(entry))

export const filterMaterialsStoredInStorages = (
  storages: HistoryStorageWithMaterial[],
  materialIds: number[]
) => {
  const materialIdsInStorages = new Set(storages.map((storage) => storage.materialId))
  return materialIds.filter((id) => materialIdsInStorages.has(id))
}
